import _defineProperty from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { getTransBg } from './color-block';

var genPickerStyle = function genPickerStyle(token) {
  var _$concat, _$concat2, _ref;

  var componentCls = token.componentCls,
      controlHeightLG = token.controlHeightLG,
      borderRadiusSM = token.borderRadiusSM,
      colorPickerInsetShadow = token.colorPickerInsetShadow,
      marginSM = token.marginSM,
      colorBgElevated = token.colorBgElevated,
      colorFillSecondary = token.colorFillSecondary,
      lineWidthBold = token.lineWidthBold,
      colorPickerHandlerSize = token.colorPickerHandlerSize,
      colorPickerHandlerSizeSM = token.colorPickerHandlerSizeSM,
      colorPickerSliderHeight = token.colorPickerSliderHeight;
  return _ref = {}, _defineProperty(_ref, "".concat(componentCls, "-select"), (_$concat = {}, _defineProperty(_$concat, "".concat(componentCls, "-palette"), {
    minHeight: controlHeightLG * 4,
    overflow: 'hidden',
    borderRadius: borderRadiusSM
  }), _defineProperty(_$concat, "".concat(componentCls, "-saturation"), {
    position: 'absolute',
    borderRadius: 'inherit',
    boxShadow: colorPickerInsetShadow,
    inset: 0
  }), _defineProperty(_$concat, "marginBottom", marginSM), _$concat)), _defineProperty(_ref, "".concat(componentCls, "-handler"), {
    width: colorPickerHandlerSize,
    height: colorPickerHandlerSize,
    border: "".concat(lineWidthBold, "px solid ").concat(colorBgElevated),
    position: 'relative',
    borderRadius: '50%',
    cursor: 'pointer',
    boxShadow: "".concat(colorPickerInsetShadow, ", 0 0 0 1px ").concat(colorFillSecondary),
    '&-sm': {
      width: colorPickerHandlerSizeSM,
      height: colorPickerHandlerSizeSM
    }
  }), _defineProperty(_ref, "".concat(componentCls, "-slider"), (_$concat2 = {
    borderRadius: colorPickerSliderHeight / 2
  }, _defineProperty(_$concat2, "".concat(componentCls, "-palette"), {
    height: colorPickerSliderHeight
  }), _defineProperty(_$concat2, "".concat(componentCls, "-gradient"), {
    borderRadius: colorPickerSliderHeight / 2,
    boxShadow: colorPickerInsetShadow
  }), _defineProperty(_$concat2, '&-alpha', getTransBg("".concat(colorPickerSliderHeight, "px"), token.colorFillSecondary)), _defineProperty(_$concat2, "marginBottom", marginSM), _$concat2)), _defineProperty(_ref, "".concat(componentCls, "-slider-container"), _defineProperty({
    display: 'flex',
    gap: marginSM
  }, "".concat(componentCls, "-slider-group"), {
    flex: 1
  })), _ref;
};

export default genPickerStyle;